import { Grid, IconButton } from "@mui/material";
import CustomTextFieldNumberComponente, { TiposTextFieldNumberEnum } from "../CustomTextFieldNumberComponente";
import { gridSizeConst10, gridSizeConst2, gridSizeMdLg6, texto } from "@/shared";
import SearchIcon from '@mui/icons-material/Search';
import { FieldError, FieldValues, UseFormReturn } from "react-hook-form";

interface CustomIdentificationSearchProps<T extends FieldValues> {
  form: UseFormReturn<T, any, any>
  onChangeValue: (aux: string) => void
  onClickSearch: () => void
  name: string
  max?: number
  defaultValue?: string
  disabled?: boolean
}

export default function CustomIdentificationSearch<T extends FieldValues>({
  form,
  name,
  onChangeValue,
  onClickSearch,
  max = 10,
  defaultValue,
  disabled = false,
}: CustomIdentificationSearchProps<T>) {

  const {
    formState: {
      errors
    },
    control,
  } = form

  return (
    <Grid container
      item
      spacing={1}
      justifyContent={'space-between'}
      alignItems={'center'}
      {...gridSizeMdLg6}
    >
      <CustomTextFieldNumberComponente
        disabled={disabled}
        size={gridSizeConst10}
        max={max}
        type={TiposTextFieldNumberEnum.IDENTIFICACION}
        label={texto.identificacion}
        error={errors[name] as FieldError | undefined}
        helperText={errors[name]?.message as string | undefined}
        control={control}
        name={name}
        defaultValue={defaultValue}
        onChangeValue={aux => onChangeValue(aux)}
      />

      <Grid item {...gridSizeConst2}>
        <IconButton onClick={(e: any) => {
          e.preventDefault();

          onClickSearch();

        }} size="small">
          <SearchIcon />
        </IconButton>
      </Grid>

    </Grid>
  )

}